// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"689f7476","5116":"689f7476"}[chunkId] + ".chunk.css";
};